import { useQuery } from "@apollo/client";

import { TLoadoutsQuery } from "MVVM/Views/CreateMontage/@types";
import { LOADOUT_QUERY } from "MVVM/GraphQL/quickEdit";

export const QuickEditLoadoutsViewModel = () => {
  const { data: loadoutsData } = useQuery<TLoadoutsQuery>(LOADOUT_QUERY, {
    variables: {
      game: 7302,
      type: "quick_edit",
    },
  });
  const loadouts = loadoutsData?.loadouts;

  return {
    loadouts,
  };
};
